export default "__VITE_ASSET__b40bd212__"